import { ReactNode, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { ModulePermissionQuery } from '../modules/user_and_permissions/models/Permission.model'
import { useGetProfile } from '../modules/user_and_permissions/providers/User.provider'

export function usePermissions(pageQuery?: ModulePermissionQuery | ModulePermissionQuery[] | string) {
  const history = useHistory()
  const userState = useGetProfile()
  const user = userState.data

  const hasAccess = useCallback(
    (q?: ModulePermissionQuery | ModulePermissionQuery[] | string): boolean => {
      if (user?.role?.status !== "ACTIVE") return false
      const code = q ?? pageQuery
      if (!code) return true
      if (Array.isArray(code)) {
        return code.length === 0 || code.some((item) => hasAccess(item))
      }
      const permissions = user.role.permissions ?? []
      if (permissions.includes(code as ModulePermissionQuery)) return true
      if (code.startsWith('manage_gamification.')) {
        const alias = code.replace('manage_gamification.', 'gamification.')
        if (permissions.includes(alias as ModulePermissionQuery)) return true
      }
      if (code.startsWith('gamification.')) {
        const alias = code.replace('gamification.', 'manage_gamification.')
        if (permissions.includes(alias as ModulePermissionQuery)) return true
      }
      return false
    },
    [pageQuery, user]
  )

  const canAccessPage = useMemo(() => hasAccess(), [hasAccess])

  const accessRedirect = useCallback(
    (q?: ModulePermissionQuery | ModulePermissionQuery[] | string, path?: string) => {
      if (q) {
        if (canAccessPage && hasAccess(q)) {
          return
        }
        if (path) return history.push(path)
        return history.goBack()
      }
    },
    [canAccessPage, hasAccess, history]
  )

  const setVisibleByAccess = (q: ModulePermissionQuery[], child: ReactNode, fallbackChild?: ReactNode) => {
    const isVisible = q.some(_ => hasAccess(_))
    return (isVisible) ? child : fallbackChild;
  }
  return { hasAccess, canAccessPage, accessRedirect, setVisibleByAccess }
}
